import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 16DEE563-B4C3-4B6D-A47F-B23151965007
 * name ray-end-arrow
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ray-end-arrow.svg
 * tags
 */
export const RayEndArrowIcon = createSvgIcon(<><path d="M1,12L5,16V13H17.17C17.58,14.17 18.69,15 20,15A3,3 0 0,0 23,12A3,3 0 0,0 20,9C18.69,9 17.58,9.83 17.17,11H5V8L1,12Z" /></>, 'RayEndArrowIcon');
export default RayEndArrowIcon